<template lang="pug">
v-dialog.d-inline(
  v-model="value" 
  persistent 
  max-width="480"
)
  v-card
    title-bar(dark) Connect Cloud CMA to LionDesk
    v-card-text
      v-layout(column)
        v-img.mb-4.mt-2(src="/static/img/cloud-cma-logo.png" height="40" contain)
        span.mt-2
          strong Use your Cloud CMA API Key to connect
        v-text-field(
          v-model="inputKey"
          flat
          autofocus
          hide-details
          label="Cloud CMA API Key"
          @focus="onApiKeyFocus"
          @blur="onApiKeyBlur"
        )
        p.caption.mt-1
          a(href="https://lonewolf.my.site.com/s/article/LD-Connect-LionDesk-with-Cloud-CMA" target="_blank")
            |Learn how to get your Cloud CMA API Key
        p.mb-0.mt-3.text-xs-center
          a(href="https://cloudagentsuite.com/tools/cma" target="_blank")
            strong Create a Cloud CMA account
    v-card-actions
      v-spacer
      v-btn(flat @click="cancel(false)") Cancel
      v-btn.primary(@click="save" :disabled="shouldDisable") Save Key
</template>

<script>
import { mapActions, mapState } from 'vuex';
import TitleBar from '@/Core/components/TitleBar';

export default {
  name: 'ConnectCmaModal',
  components: {
    TitleBar,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      apiKey: '',
      inputKey: '',
      cmaLogo: '../../assets/images/cloud-cma-logo.png',
    }
  },
  watch: {
    isLoading: {
      handler(newVal) {
        if (!this.value || newVal || this.hasError || this.hasApiKeyError) return;
        this.cancel(true);
      },
    },
  },
  computed: {
    ...mapState('cma', ['isLoading', 'hasError', 'hasApiKeyError']),
    shouldDisable() {
      return this.apiKey.length === 0 || !this.apiKey || this.isLoading;
    },
  },
  methods: {
    ...mapActions('cma', ['saveCmaApiKey']),
    obfuscateKey(key) {
      if (key.length < 3) return key;
      let first = key.slice(0, 3);
      let rest = key.substring(3);
      if (rest.length > 3) {
        let end = rest.slice(-3);
        return first + end.padStart(rest.length, '*');
      }

      return first.padEnd(key.length, '*');
    },
    onApiKeyFocus() {
      this.inputKey = this.apiKey;
    },
    onApiKeyBlur() {
      this.apiKey = this.inputKey;
      this.inputKey = this.obfuscateKey(this.inputKey);
    },
    save() {
      this.saveCmaApiKey(this.apiKey);
    },
    cancel(isSaved) {
      this.apiKey = '';
      this.inputKey = '';
      
      if (isSaved) this.$emit('save');
      this.$emit('close');
    },
  },
}
</script>
